// extracted by mini-css-extract-plugin
export var cardTitle = "_hu-1";
export var commentBubble = "_hu-e";
export var commentForm = "_hu-a";
export var commentInput = "_hu-b";
export var commentLabel = "_hu-d";
export var commentPrompt = "_hu-9";
export var csatCard = "_hu-0";
export var feedbackSection = "_hu-7";
export var starDisabled = "_hu-6";
export var starEmpty = "_hu-5";
export var starFilled = "_hu-4";
export var starWrapper = "_hu-3";
export var starsContainer = "_hu-2";
export var submittedComment = "_hu-c";
export var thankYouText = "_hu-8";